import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserInfo } from '../../../models/user-info.model';


export interface UserRequest {
  username: string;
  email: string;
  enabled: boolean;
  roles: string[];
  userInfo: {
    firstName: string;
    lastName: string;
    birthDate: Date;
  };
}

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html'
})
export class UserFormComponent implements OnInit {

  userForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  userId: number;
  user: UserRequest;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder) {
      this.userId = +this.route.snapshot.params.userId;
      this.route.params.subscribe(params => {
        this.userId = +params.userId;
      });
    }

  ngOnInit() {
    // TODO: sostituire con resolver
    this.buildForm();

    if (this.userId) {
      this.getUser();
    }
  }

  private getUser() {
    this.userService.getUser(this.userId).subscribe(user => {
      this.user = user;
      this.userForm.patchValue({
        id: user.id,
        username: user.username,
        email: user.email,
        enabled: user.enabled,
        roles: user.roles,
        userInfo: user.userInfo || new UserInfo()
      });
      this.userForm.removeControl('password');
    });
  }

  private buildForm() {
    this.userForm = this.formBuilder.group({
      id: new FormControl(null),
      username: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.email]),
      enabled: new FormControl(false),
      roles: new FormControl([]),
      userInfo: new FormControl(null)
    });
  }

  get f() { return this.userForm.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.userForm.invalid) {
        return;
    }

    this.saveUser();
  }

  private saveUser() {
    if (!this.userId) {
      this.createUser();
    } else {
      this.updateUser();
    }
  }

  onRoleSelected(selectedRoles: string[]) {
    this.userForm.patchValue({
      roles: selectedRoles
    });
  }

  private createUser() {
    this.userService.createUser(this.userForm.value).subscribe(res => {
      this.router.navigate(['../'], {relativeTo: this.route});
    });
  }

  private updateUser() {
    this.userService.updateUser(this.userId, this.userForm.value).subscribe();
  }
}
